import { LaskunListaustietorivi, LaskunListaustyyppi, LaskunTila } from '@lemon/core-firebase/model/lasku'
import { LocalMonth, NumberDate, NumberMonth } from '@lemon/core/model/common'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'

export interface YhteensaRivi {
  valuutta: string
  avoinna: number
  laskutettu: number
}

export interface KuukaudenPaivavali {
  alkaen: NumberDate
  /** Seuraavan kuukauden ensimmäinen päivä, joka ei kuulu väliin */
  ennen: NumberDate
}

export function annaKuukaudenPaivavali(kuukausi: NumberMonth, dateService: DateService): KuukaudenPaivavali {
  return { alkaen: kuukausi * 100 + 1, ennen: dateService.lisaaKuukausiaKuukaudenNumero(kuukausi, 1) * 100 + 1 }
}

/** Kuukausirajauksen vaihtoehdot: kuluva kuukausi ja sitä edeltävät, uusin ensin. */
export function annaRajattavatKuukaudet(nykyinen: LocalMonth, maara: number, dateService: DateService): LocalMonth[] {
  const kuukaudet: LocalMonth[] = []
  let kuukausi = nykyinen
  while (kuukaudet.length < maara) {
    kuukaudet.push(kuukausi)
    kuukausi = dateService.lisaaKuukausiaLocalMonth(kuukausi, -1)
  }
  return kuukaudet
}

/**
 * Näkyvien rivien yhteissummat valuutoittain. Muun valuutan lasku, jolla on tallennettu eurokurssi, lasketaan euroihin;
 * ilman kurssia se jää omaksi valuutakseen. Avoimeen summaan ei lasketa luonnoksia eikä muistutus- tai hyvitysrivejä,
 * koska niiden avoin määrä on jo laskun päärivillä.
 */
export function laskeYhteissummatValuutoittain(rivit: LaskunListaustietorivi[], annaEurokurssi: (rivi: LaskunListaustietorivi) => number | undefined, currencyService: CurrencyService): YhteensaRivi[] {
  const valuutoittain = new Map<string, YhteensaRivi>()
  for (const rivi of rivit) {
    const kurssi = annaEurokurssi(rivi)
    const valuutta = kurssi ? 'EUR' : rivi.valuutta
    let yhteensa = valuutoittain.get(valuutta)
    if (!yhteensa) {
      yhteensa = { valuutta, avoinna: 0, laskutettu: 0 }
      valuutoittain.set(valuutta, yhteensa)
    }
    const onkoLaskunPaarivi = rivi.tyyppi === LaskunListaustyyppi.TAVALLINEN || rivi.tyyppi === LaskunListaustyyppi.VANHEMPI
    if (rivi.tila !== LaskunTila.luonnos && onkoLaskunPaarivi) {
      yhteensa.avoinna += muunnaEuroiksi(rivi.avoinna, kurssi, currencyService)
    }
    yhteensa.laskutettu += muunnaEuroiksi(rivi.summa, kurssi, currencyService)
  }
  return [...valuutoittain.values()].sort((a, b) => a.laskutettu - b.laskutettu)
}

function muunnaEuroiksi(summa: number, kurssi: number | undefined, currencyService: CurrencyService): number {
  if (!kurssi || !summa) {
    return summa
  }
  return currencyService.roundHalfUp(summa * kurssi, 2)
}
